import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, MapPin, Phone } from 'lucide-react';
import { Logo } from './Logo';
import { useI18n } from '../i18n/I18nProvider';
import { FOOTER } from '../constants/testIds';

export function Footer() {
  const { t } = useI18n();
  return (
    <footer data-testid={FOOTER.root} className="bg-[#0F172A] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Logo light size="lg" />
            <p
              data-testid={FOOTER.tagline}
              className="font-serif italic text-3xl md:text-4xl mt-8 leading-tight"
            >
              « {t('footer.tagline')} »
            </p>
            <p className="text-white/60 text-sm mt-4 max-w-md">
              {t('footer.since')} — {t('footer.company')}
            </p>
            <div className="flex items-center gap-4 mt-8">
              <a
                href="https://www.facebook.com/tahitianmove"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 rounded-full flex items-center justify-center hover:bg-white hover:text-ocean transition-colors"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://www.instagram.com/tahitian_move?igsh=aWphbDQyZGhiaXZ1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 rounded-full flex items-center justify-center hover:bg-white hover:text-ocean transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="eyebrow text-white/60 mb-5">{t('footer.explore')}</h4>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to="/heritage" className="hover:text-lagoon transition-colors">{t('nav.heritage')}</Link></li>
              <li><Link to="/collections" className="hover:text-lagoon transition-colors">{t('nav.collections')}</Link></li>
              <li><Link to="/boutique" className="hover:text-lagoon transition-colors">{t('nav.boutique')}</Link></li>
              <li><Link to="/b2b" className="hover:text-lagoon transition-colors">{t('nav.b2b')}</Link></li>
              <li><Link to="/contact" className="hover:text-lagoon transition-colors">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="eyebrow text-white/60 mb-5">{t('nav.boutique')}</h4>
            <ul className="space-y-3 text-sm font-light text-white/80">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-lagoon shrink-0 mt-1" />
                <span>Fare Ute, Papeete<br />Polynésie française</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-lagoon shrink-0 mt-1" />
                <a href="tel:+68940502300" className="hover:text-lagoon transition-colors">
                  +689 40 50 23 00
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-lagoon shrink-0 mt-1" />
                <a href="mailto:contact@tahitianmove.com" className="hover:text-lagoon transition-colors">
                  contact@tahitianmove.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Tahitian Move · SARL Blue Star — {t('footer.rights')}</p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" className="hover:text-white/70 transition-colors">
              {t('footer.legal')}
            </Link>
            <Link to="/admin/login" className="hover:text-white/70 transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
